export default ['signin', 'signup', 'avatars'];
